import React from 'react';
import HeroStyle2 from '../Hero/HeroStyle2';
import Section from '../Section';
import AboutSectionStyle3 from '../Section/AboutSection/AboutSectionStyle3';
import DepartmentSectionStyle4 from '../Section/DepartmentSection/DepartmentSectionStyle4';
import TestimonialSectionStyle2 from '../Section/TestimonialSection/TestimonialSectionStyle2';
import WorkingProcess from '../Section/WorkingProcess';
import BannerSectionStyle2 from '../Section/BannerSection/BannerSectionStyle2';
import BlogSectionStyle3 from '../Section/BlogSection/BlogSectionStyle3';
import FaqSectionStyle2 from '../Section/FaqSection/FaqSectionStyle2';
import AppointmentSectionStyle2 from '../Section/AppointmentSection/AppointmentSectionStyle2';
import BrandsSectionStyle2 from '../Section/BrandsSection/BrandsSectionStyle2';
import { pageTitle } from '../../helpers/PageTitle';
const departmentData = [
  {
    title: 'Ossur Direct Solutions',
    iconUrl: '/images/home_2/ossur2.png',
    href: 'https://www.ossur.com/en-us',
  },
  {
    title: 'Martin Bionics Interface Systems',
    iconUrl: '/images/home_2/martin2.png',
    href: 'https://martinbionics.com/',
  },
  {
    title: 'Slingshot Bionics',
    iconUrl: '/images/home_2/department_slingshot.png',
    href: 'https://slingshotbionics.com/',
  },
  {
    title: 'Otto Bock Technology',
    iconUrl: '/images/home_2/ottobock2.png',
    href: '/departments/ottobock',
  },
  /*  {
    title: 'Custom Prosthetic Design',
    iconUrl: '/images/home_2/department_icon_5.svg',
    href: '/departments/custom-prosthetics',
  },
  {
    title: 'Orthotic Bracing Solutions',
    iconUrl: '/images/home_2/department_icon_6.svg',
    href: '/departments/bracing',
  }, */
];
const testimonialData = [
  {
    text: 'the staff is friendly and makes you feel comfortable and Mr Gregg makes sure you are comfortable with your new prosthetics and takes the time to listen to you concerns with your feet and about your walking comfortable”',
    ratingNumber: '5',
    avatarImgUrl: '/images/home_1/avatar_1.png',
    avatarName: 'Bob Spears',
    avatarDesignation: 'Walker, LA',
  },
  {
    text: 'The absolute best! Had me in and out in a flash! Extremely kind, cared and took care of my problem! Highly recommend!!!',
    ratingNumber: '5',
    avatarImgUrl: '/images/home_1/avatar_1.png',
    avatarName: 'Brandon Dykes',
    avatarDesignation: 'Baton Rouge, LA',
  },
  {
    text: 'I owe my leg to Rick and the team at Freedom Prosthetics. When other places had given up, Rick didn’t. His knowledge, patience, and care made all the difference. Thanks to him, I’m not only walking — I’m living life again.',
    ratingNumber: '5',
    avatarImgUrl: '/images/home_1/avatar_1.png',
    avatarName: 'Floyd Feske Jr.',
    avatarDesignation: 'Denham Springs, LA',
  },
];
const workingProcessData = [
  {
    title: 'Book Appointment',
    subTitle:
      'You can book an appointment with us by <br />calling our office or filling out our contact form form.',
    iconUrl: '/images/home_2/wording_process_icon_1.svg',
    number: '01',
  },
  {
    title: 'Visit Our Facility',
    subTitle:
      'On the day of your appointment, come to our <br />facility at the designated time. Our staff will greet <br />you and guide you through the check-in process.',
    iconUrl: '/images/home_2/wording_process_icon_2.svg',
    number: '02',
  },
  {
    title: 'Meet with Our Skilled <br />Team',
    subTitle:
      'You’ll meet with one of our experienced <br />prosthetic specialists who will conduct a <br />thorough evaluation and help create a <br />personalized plan for your needs.',
    iconUrl: '/images/home_2/wording_process_icon_3.svg',
    number: '03',
  },
  {
    title: 'Follow-up Care',
    subTitle:
      'We will schedule any necessary follow-up <br />appointments, tests, or procedures to ensure <br />that you receive the best possible care.',
    iconUrl: '/images/home_2/wording_process_icon_4.svg',
    number: '04',
  },
];
const blogData = [
  {
    title: 'The Benefits of Mindfulness Meditation for Stress and Anxiety',
    thumbUrl: 'images/home_1/post_1.jpeg',
    date: 'May 1, 2023',
  },
  {
    title: 'Healthy Eating on a Budget: Tips and Strategies',
    thumbUrl: 'images/home_1/post_2.jpeg',
    date: 'May 4, 2023',
  },
  {
    title: 'The Importance of Regular Cancer Screenings and Early Detection',
    thumbUrl: 'images/home_1/post_3.jpeg',
    date: 'May 1, 2023',
  },
];
const faqData = [
  {
    title: 'What services does Freedom Prosthetics offer?',
    content:
      'We provide comprehensive prosthetic and orthotic care, including pre- and post-operative consultations, custom device fittings, long-term follow-up, repairs, and maintenance. We also offer mobile, van-based prosthetic care for patients who need on-site services or face transportation challenges.',
  },
  {
    title: 'Do you offer mobile or in-home prosthetic services?',
    content:
      'Yes. Freedom Prosthetics offers mobile van-based care for patients who are unable to travel to our clinic. This includes in-home fittings, follow-up adjustments, and minor repairs. Contact us to learn more or to see if this service is available in your area.',
  },
  {
    title: 'How do I schedule an appointment with Freedom Prosthetics?',
    content:
      'To schedule a consultation, call our office at (225) 665‑0323. We recommend obtaining a prescription or referral from your physician prior to the appointment. Let us know if you’re interested in our mobile care services when booking.',
  },
  {
    title: 'Do you accept insurance?',
    content:
      'Yes—we work with most major insurance providers. Bring all insurance cards to your appointment. Our team will verify your benefits and explain any out-of-pocket costs before treatment begins.',
  },
  {
    title: 'What should I bring to my appointment?',
    content:
      'Please bring your prescription or referral, a valid photo ID, and all insurance cards. If you are covered by multiple insurance plans, make sure to bring each card.',
  },
  {
    title: 'Can I get a cost estimate before my consultation?',
    content:
      'No. We cannot provide accurate estimates without a clinical evaluation. After your initial consultation, our team will generate a detailed estimate tailored to your prescription and insurance coverage.',
  },
  {
    title: 'How often should I schedule follow‑up visits?',
    content:
      'We recommend routine follow-ups every 6 months to ensure your device continues to fit properly and functions well. Additional visits can be scheduled if you experience discomfort or changes in your condition.',
  },
  {
    title: 'Do you provide repairs or replacements?',
    content:
      'Yes. We handle all repairs and adjustments in-house or via our mobile van services when applicable. Please call ahead to schedule a repair visit, or let us know if you need mobile service.',
  },
  {
    title: 'Are peer support resources available?',
    content:
      'Yes. We believe in supporting the whole person—not just the device. Ask us about local peer groups and veteran-centered support resources that can help you navigate life after limb loss.',
  },
];

const brandData = [
  {
    imgUrl: '/images/home_2/ossur2.png',
    imgAlt: 'Ossur',
  },
  {
    imgUrl: '/images/home_2/ottobock2.png',
    imgAlt: 'Brand',
  },
  {
    imgUrl: '/images/home_2/department_slingshot.png',
    imgAlt: 'Brand',
  },
  {
    imgUrl: '/images/home_2/ottobock2.png',
    imgAlt: 'Brand',
  },
  {
    imgUrl: '/images/brand_5.png',
    imgAlt: 'Brand',
  },
  {
    imgUrl: '/images/brand_6.png',
    imgAlt: 'Brand',
  },
  {
    imgUrl: '/images/brand_7.png',
    imgAlt: 'Brand',
  },
];
export default function HomeStyle2() {
  pageTitle('Home');
  return (
    <>
      <HeroStyle2
        title='Compassionate care, Freedom Prosthetics!'
        subTitle='We don’t just make prosthetic limbs. Here at Freedom we offer a full line of bracing options to take care of all of your needs. Give us a call and make an appointment with one of our clinicians today.'
        bgUrl='/images/home_2/hero_bg.jpeg'
        videoBgUrl='/videos/hero_br.webm'
        /* imgUrl='/images/home_2/patents.gif' */
        videoBtnText='Regain Your Freedom'
        videoUrl='https://www.youtube.com/embed/e2cHp9hxlE0'
        btnText='Freedom Prosthetics LLC'
        btnUrl='/'
        funfactList={[
          { number: '70+', title: 'Years of combined experience' },
          { number: '100%', title: 'Dedicated professional staff' },
          { number: '100+', title: 'Veterans and first responders served' },
        ]}
      />
      <Section bottomMd={190} bottomLg={145} bottomXl={105}>
        <AboutSectionStyle3
          titleUp='ABOUT US'
          title='Freedom Prosthetics & Orthotics is a locally and family-owned clinic built on compassion, innovation, and results.'
          subTitle='We specialize in custom prosthetic limbs and a full range of bracing solutions designed to restore mobility and improve quality of life. Our certified clinicians are dedicated to providing personalized care, proudly serving veterans, first responders, and the wider community. At Freedom, we stay on the cutting edge of technology to ensure every patient receives the best possible support — because to us, it’s more than healthcare; it’s family care.'
          imgUrl='/images//home_2/about.svg'
        />
      </Section>
      <Section bottomMd={125} bottomLg={125} bottomXl={85}>
        <DepartmentSectionStyle4
          sectionTitle='Advanced Solutions We Trust'
          sectionTitleUp='We proudly fit and customize devices from some of the most trusted names in prosthetics and orthotics'
          data={departmentData}
        />
      </Section>
      <Section
        className='cs_bg_filed'
        style={{ backgroundImage: `url(/images/home_2/testimonial_bg.svg)` }}
        topMd={190}
        topLg={145}
        topXl={105}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <TestimonialSectionStyle2
          sectionTitle='What Our Patients Say <br /> About Us'
          sectionTitleUp='TESTIMONIALS'
          data={testimonialData}
        />
      </Section>
      <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <WorkingProcess
          sectionTitle='How it Works'
          sectionTitleUp=''
          sectionTitleDown=''
          sectionSubTitle=''
          data={workingProcessData}
        />
      </Section>
      <Section>
        <BannerSectionStyle2
          bgUrl='/images/home_2/cta_bg.png'
          title={`<span style="text-shadow: 2px 2px 6px rgba(0,0,0,0.95); color: #ffffff;">
      Don’t Let Your Health Take a Backseat!
    </span>`}
          subTitle={`<span style="text-shadow:
      2px 2px 4px rgba(0,0,0,0.9),
      4px 4px 6px rgba(0,0,0,0.8),
      6px 6px 10px rgba(0,0,0,0.6);
      color: #ffffff;">
      We offer both in-clinic and mobile prosthetic care—so whether you come to us or we come to you, your health stays in the driver’s seat.<br />
      Schedule your appointment today!
    </span>`}
        />
      </Section>

      <Section topMd={190} topLg={145} topXl={105}>
        <BlogSectionStyle3
          sectionTitle='Latest Update'
          sectionTitleUp='BLOG POSTS'
          sectionTitleDown=''
          sectionSubTitle=''
          data={blogData}
        />
      </Section>
      {/* Start FAQ Section */}
      <Section
        topMd={190}
        topLg={145}
        topXl={105}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <FaqSectionStyle2
          data={faqData}
          sectionTitle='Usually Asked'
          sectionTitleUp='What People'
        />
      </Section>
      {/* End FAQ Section */}
      <Section>
        <AppointmentSectionStyle2
          bgUrl='/images/home_2/appointment_bg.svg'
          imgUrl='/images/home_2/appointment_img.png'
          sectionTitle='Contact Us'
          sectionTitleUp=''
        />
      </Section>
      {/* <Section
        topMd={200}
        topLg={150}
        topXl={110}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <BrandsSectionStyle2 data={brandData} />
      </Section> */}
    </>
  );
}
